import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-two-column',
  templateUrl: './blog-two-column.component.html',
  styleUrls: ['./blog-two-column.component.scss']
})
export class BlogTwoColumnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
